import { createContext, useContext, useState } from "react";
import { DefaultShowTakeReading } from "lib/consts/inspections/takeReading";

export const TakeReadingContext = createContext();
TakeReadingContext.displayName = "InspectionTakeReading";
export const useTakeReading = () => useContext(TakeReadingContext);

const TakeReadingProvider = ({ children }) => {
    const [showTakeReading, setShowTakeReading] = useState(DefaultShowTakeReading);

    return (
        <TakeReadingContext.Provider value={{ showTakeReading, setShowTakeReading }}>
            {children}
        </TakeReadingContext.Provider>
    );
};

export default TakeReadingProvider;
